import React from "react";
import { Link } from "react-router-dom";

import NavMenuDesktop from "../common/NavMenuDesktop";
import NavMenuMobile from "../common/NavMenuMobile";

import "../../assests/css/PrivacyPolicy.css";

function PrivacyPolicy() {
    return (
        <>
            {/* ================= HEADER / NAVIGATION ================= */}

            <NavMenuDesktop />
            <NavMenuMobile />


            {/* ================= PRIVACY POLICY ================= */}

            <section className="privacy-policy">


                {/* ================= PRIVACY HEADER ================= */}

                <div className="privacy-header">

                    {/* BACK TO HOME */}

                    <Link
                        to="/"
                        className="privacy-home"
                    >
                        <i className="fa fa-arrow-left"></i>
                        <span>Back to Home</span>
                    </Link>


                    <span className="privacy-label">
                        PRIME LUXURY
                    </span>


                    <h1>
                        Privacy Policy
                    </h1>


                    <p>
                        Your privacy and personal information are important
                        to us. This Privacy Policy explains how Prime Luxury
                        Passenger Transport LLC collects, uses and protects
                        your information.
                    </p>


                    <span className="privacy-date">
                        Last Updated: September 11, 2026
                    </span>

                </div>



                {/* ================= CONTENT ================= */}

                <div className="privacy-container">


                    {/* ================= 01 INTRODUCTION ================= */}

                    <div className="privacy-section">

                        <div className="privacy-number">
                            01
                        </div>

                        <div className="privacy-content">

                            <h2>
                                Introduction
                            </h2>

                            <p>
                                Prime Luxury Passenger Transport LLC
                                ("Prime Luxury", "we", "our" or "us")
                                respects your privacy and is committed to
                                protecting your personal information.
                            </p>

                            <p>
                                This Privacy Policy explains how we collect,
                                use, store and protect information when you
                                visit our website or request our chauffeur,
                                limousine, airport transfer, city tour and
                                passenger transportation services.
                            </p>

                        </div>

                    </div>



                    {/* ================= 02 INFORMATION ================= */}

                    <div className="privacy-section">

                        <div className="privacy-number">
                            02
                        </div>

                        <div className="privacy-content">

                            <h2>
                                Information We Collect
                            </h2>

                            <p>
                                We may collect information that you
                                voluntarily provide when requesting or
                                booking our services, including:
                            </p>

                            <ul>

                                <li>
                                    Name and contact information
                                </li>

                                <li>
                                    Mobile and WhatsApp number
                                </li>

                                <li>
                                    Email address
                                </li>

                                <li>
                                    Pickup and drop-off locations
                                </li>

                                <li>
                                    Travel date and time
                                </li>

                                <li>
                                    Passenger information
                                </li>

                                <li>
                                    Flight number and travel details
                                </li>

                                <li>
                                    Vehicle and service preferences
                                </li>

                            </ul>

                        </div>

                    </div>



                    {/* ================= 03 HOW WE USE ================= */}

                    <div className="privacy-section">

                        <div className="privacy-number">
                            03
                        </div>

                        <div className="privacy-content">

                            <h2>
                                How We Use Your Information
                            </h2>

                            <p>
                                We use your information to provide and improve
                                our transportation services. This may include:
                            </p>

                            <ul>

                                <li>
                                    Processing booking and service requests
                                </li>

                                <li>
                                    Contacting you regarding your booking
                                </li>

                                <li>
                                    Arranging vehicles and professional
                                    chauffeurs
                                </li>

                                <li>
                                    Confirming pickup and travel details
                                </li>

                                <li>
                                    Providing customer support
                                </li>

                                <li>
                                    Improving our website and services
                                </li>

                                <li>
                                    Communicating important service
                                    informationimport NavMenuDesktop from './../common/NavMenuDesktop';
import NavMenuMobile from './../common/NavMenuMobile';

                                </li>

                            </ul>

                        </div>

                    </div>



                    {/* ================= 04 WHATSAPP ================= */}

                    <div className="privacy-section">

                        <div className="privacy-number">
                            04
                        </div>

                        <div className="privacy-content">

                            <h2>
                                WhatsApp Communication
                            </h2>

                            <p>
                                Our website may allow you to contact us
                                through WhatsApp for booking enquiries and
                                customer support.
                            </p>

                            <p>
                                When you choose to contact us through
                                WhatsApp, your communication and information
                                may also be subject to WhatsApp's own privacy
                                policies and terms of service.
                            </p>

                            <p>
                                We use the information you provide through
                                WhatsApp to respond to your enquiry and
                                arrange transportation services.
                            </p>

                        </div>

                    </div>



                    {/* ================= 05 SHARING ================= */}

                    <div className="privacy-section">

                        <div className="privacy-number">
                            05
                        </div>

                        <div className="privacy-content">

                            <h2>
                                Sharing Your Information
                            </h2>

                            <p>
                                We do not sell your personal information to
                                third parties.
                            </p>

                            <p>
                                Your information may only be shared when
                                necessary to provide our services, including
                                with authorized drivers, chauffeurs,
                                operational staff or service partners
                                involved in your transportation booking.
                            </p>

                            <p>
                                We may also disclose information when required
                                by applicable laws, regulations or legal
                                authorities.
                            </p>

                        </div>

                    </div>



                    {/* ================= 06 DATA SECURITY ================= */}

                    <div className="privacy-section">

                        <div className="privacy-number">
                            06
                        </div>

                        <div className="privacy-content">

                            <h2>
                                Data Security
                            </h2>

                            <p>
                                We take reasonable administrative and
                                technical measures to protect your personal
                                information from unauthorized access, loss,
                                misuse or disclosure.
                            </p>

                            <p>
                                However, no online system or method of
                                electronic communication can be guaranteed
                                to be completely secure.
                            </p>

                        </div>

                    </div>



                    {/* ================= 07 COOKIES ================= */}

                    <div className="privacy-section">

                        <div className="privacy-number">
                            07
                        </div>

                        <div className="privacy-content">

                            <h2>
                                Cookies and Website Information
                            </h2>

                            <p>
                                Our website may use cookies and similar
                                technologies to improve website functionality,
                                understand visitor activity and enhance the
                                user experience.
                            </p>

                            <p>
                                You can control or disable cookies through
                                your browser settings. Please note that some
                                website features may not function properly if
                                cookies are disabled.
                            </p>

                        </div>

                    </div>



                    {/* ================= 08 THIRD PARTY ================= */}

                    <div className="privacy-section">

                        <div className="privacy-number">
                            08
                        </div>

                        <div className="privacy-content">

                            <h2>
                                Third-Party Services
                            </h2>

                            <p>
                                Our website may include links or integrations
                                with third-party platforms and services,
                                including WhatsApp, Google Maps and social
                                media platforms.
                            </p>

                            <p>
                                These third-party services operate under
                                their own privacy policies. Prime Luxury
                                Passenger Transport LLC is not responsible
                                for the privacy practices of third-party
                                websites or services.
                            </p>

                        </div>

                    </div>



                    {/* ================= 09 RETENTION ================= */}

                    <div className="privacy-section">

                        <div className="privacy-number">
                            09
                        </div>

                        <div className="privacy-content">

                            <h2>
                                Data Retention
                            </h2>

                            <p>
                                We retain personal information only for as
                                long as necessary to provide our services,
                                manage bookings, meet operational
                                requirements and comply with applicable
                                legal obligations.
                            </p>

                        </div>

                    </div>



                    {/* ================= 10 RIGHTS ================= */}

                    <div className="privacy-section">

                        <div className="privacy-number">
                            10
                        </div>

                        <div className="privacy-content">

                            <h2>
                                Your Privacy Rights
                            </h2>

                            <p>
                                You may contact us to request information
                                about the personal data we hold about you
                                or to request correction of inaccurate
                                information, subject to applicable laws
                                and regulations.
                            </p>

                        </div>

                    </div>



                    {/* ================= 11 CHILDREN ================= */}

                    <div className="privacy-section">

                        <div className="privacy-number">
                            11
                        </div>

                        <div className="privacy-content">

                            <h2>
                                Children's Privacy
                            </h2>

                            <p>
                                Our transportation services and website are
                                not intended to knowingly collect personal
                                information directly from children without
                                appropriate authorization.
                            </p>

                        </div>

                    </div>



                    {/* ================= 12 POLICY CHANGES ================= */}

                    <div className="privacy-section">

                        <div className="privacy-number">
                            12
                        </div>

                        <div className="privacy-content">

                            <h2>
                                Changes to This Privacy Policy
                            </h2>

                            <p>
                                We may update this Privacy Policy from time
                                to time to reflect changes in our services,
                                website operations or legal requirements.
                            </p>

                            <p>
                                Any updates will be published on this page
                                with a revised "Last Updated" date.
                            </p>

                        </div>

                    </div>



                    {/* ================= CONTACT ================= */}

                    <div className="privacy-contact">


                        <div className="privacy-contact-icon">

                            <i className="fa fa-shield-alt"></i>

                        </div>


                        <div>

                            <span>
                                QUESTIONS ABOUT PRIVACY?
                            </span>


                            <h2>
                                Contact Prime Luxury
                            </h2>


                            <p>
                                If you have questions about this Privacy
                                Policy or how we handle your information,
                                please contact us.
                            </p>


                            <div className="privacy-contact-links">


                                {/* PHONE */}

                                <a
                                    href="tel:+971501011783"
                                >
                                    <i className="fa fa-phone"></i>

                                    <span>
                                        +971 50 101 1783
                                    </span>
                                </a>



                                {/* WHATSAPP */}

                                <a
                                    href="https://wa.me/971501011783"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <i className="fab fa-whatsapp"></i>

                                    <span>
                                        WhatsApp Us
                                    </span>
                                </a>



                                {/* EMAIL */}

                                <a
                                    href="mailto:info@dxblimo.com"
                                >
                                    <i className="fa fa-envelope"></i>

                                    <span>
                                        info@dxblimo.com
                                    </span>
                                </a>


                            </div>


                        </div>


                    </div>


                </div>


            </section>
        </>
    );
}

export default PrivacyPolicy;